<template>
  <v-text-field
    v-model="text"
    :searchable="true"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
  />
</template>

<script>
import blipModel from '@/mixins/blip-model';

export default {
  name: 'CampaignNameFilter',
  mixins: [
    blipModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({ value: '' }),
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.$t('components.filters.CampaignNameFilter.label');
    },
    placeholder() {
      return this.$t('components.filters.CampaignNameFilter.placeholder');
    },
    text: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        let value;

        if (newValue !== null) {
          value = {
            value: newValue,
          };
        }

        this.$emit('input', value);
      },
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
